import { Stack, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { ChartsTooltipContainer, useAxesTooltip } from "@mui/x-charts"
import CircleIcon from "@mui/icons-material/Circle"
import { DateTime } from "luxon"

import useDevices from "helpers/hooks/useDevices"
import ChartTooltipCard from "widgets/plots/mui/ChartTooltipCard"
import { getTowerTooltipLabel } from "./helpers"

interface MuiTowerTooltipProps {
  trigger?: "axis" | "item" | "none" | undefined
  labelType?: "fromTo" | "fieldDevice" | "field"
}

const MuiTowerTooltip = ({ trigger, labelType = "fromTo" }: MuiTowerTooltipProps) => {
  const { t } = useTranslation()
  const axes = useAxesTooltip()
  const { devsWRelsById } = useDevices()

  // Tooltip only for X axes, one axis of type "_time"
  // Not handling multiple axes or multiple time axes
  // Also not handling trigger "item"
  const timeAxis = axes !== null && axes[0].axisId === "_time" ? axes[0] : null

  const formattedDate = timeAxis?.axisValue
    ? DateTime.fromJSDate(timeAxis.axisValue as Date).toFormat("yyyy-MM-dd HH:mm")
    : ""

  return (
    <ChartsTooltipContainer trigger={trigger}>
      {trigger === "axis" && timeAxis && (
        <ChartTooltipCard title={formattedDate}>
          {timeAxis.seriesItems.map(
            (s) =>
              s.formattedValue !== null && (
                <Stack
                  direction="row"
                  gap={1}
                  key={s.seriesId}
                  alignItems="center"
                  width={"100%"}
                >
                  <CircleIcon sx={{ fontSize: 8, color: s.color }} />
                  <Stack
                    direction="row"
                    justifyContent={"space-between"}
                    width={"100%"}
                    gap={2}
                  >
                    <Typography>
                      {getTowerTooltipLabel(
                        s.seriesId as string,
                        labelType,
                        devsWRelsById,
                        t,
                      )}
                    </Typography>
                    <Typography>{s.formattedValue}</Typography>
                  </Stack>
                </Stack>
              ),
          )}
        </ChartTooltipCard>
      )}
    </ChartsTooltipContainer>
  )
}

export default MuiTowerTooltip
